/* GH #2809: the card in place of a block that failed to render */
.card {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border: 1px solid var(--tuna-palette-divider);
  border-radius: var(--tuna-shape-radius-md);
  background-color: var(--tuna-palette-background-paper);
  color: var(--tuna-palette-text-primary);
  user-select: none;
}

.icon {
  flex-shrink: 0;
  color: var(--tuna-palette-error-main);
}

.text {
  flex: 1 1 200px;
  min-width: 0;
}

.title {
  font-size: var(--tuna-typography-body1-fontSize);
  line-height: var(--tuna-typography-body1-lineHeight);
}

.subline {
  font-size: var(--tuna-typography-body2-fontSize);
  line-height: var(--tuna-typography-body2-lineHeight);
  color: var(--tuna-palette-text-secondary);
}

.actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.inline {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--tuna-palette-error-main);
  user-select: none;
}
